import React, { useState, useCallback } from 'react';
import { Container } from 'react-bootstrap';
import Common from '../../shared/Common';
import type { IIncomeData } from '../../../interfaces/IIncomeData';
import IncomesTable from './IncomesTable';
import Income from '../income/Income';
import type { IPaginationProps } from './IncomesTable';

import './style.css';

const Incomes = () => {
  const [incomes, setIncomes] = useState<IIncomeData[]>([]);
  const [loading, setLoading] = useState(true);
  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [totalRevenue, setTotalRevenue] = useState(0);
  const [modalShow, setModalShow] = useState(false);
  const [selectedIncomeId, setSelectedIncomeId] = useState(0);
  const [fetchTrigger, setFetchTrigger] = useState(0);
  const fetchIdRef = React.useRef(0);

  const fetchData = useCallback(
    async ({ pageIndex, pageSize, sortBy, filters }: IPaginationProps) => {
      setLoading(true);
      const fetchId = ++fetchIdRef.current;
      const filterRequest = filters.map((f) => '&' + f.id + 'Filter=' + f.value).join('');
      let sortByRequest = '';
      if (sortBy.length > 0) {
        sortByRequest = sortBy.map((s) => '&sortBy=' + s.id + (s.desc ? ' DESC' : ' ASC')).join('');
      } else {
        sortByRequest = '&sortBy=incomeId DESC';
      }
      const requestUrl =
        'api/incomes/getIncomes?pageIndex=' +
        pageIndex +
        '&pageSize=' +
        pageSize +
        filterRequest +
        sortByRequest;
      const response = await Common.authorizedFetch(requestUrl, undefined, true);
      const data = await response.json();
      if (data.success) {
        if (fetchId === fetchIdRef.current) {
          if ((data.result.incomes?.length ?? 0) > 0) {
            setIncomes(data.result.incomes);
            setPageCount(Math.ceil(data.result.incomes[0].totalCount / pageSize));
            setTotalCount(data.result.incomes[0].totalCount);
            setTotalRevenue(data.result.incomes[0].totalRevenue);
          } else {
            setIncomes([]);
            setPageCount(0);
          }
          setLoading(false);
        }
      }
    },
    []
  );

  const showEditIncomeModal = (incomeId: number) => {
      setSelectedIncomeId(incomeId);
      setModalShow(true);
  };

  return (
    <Container className='mt-2'>
      <h2 className='mb-3' id='tabelLabel'>
        Przychody
      </h2>
      <IncomesTable
        data={incomes}
        loading={loading}
        totalCount={totalCount}
        totalPageCount={pageCount}
        totalRevenue={totalRevenue}
        fetchData={fetchData}
        fetchTrigger={fetchTrigger}
        showEditIncomeModal={showEditIncomeModal}
      />
      <Income
        show={modalShow}
        onHide={() => {
          setModalShow(false);
          setSelectedIncomeId(0);
        }}
        onIncomeSave={() => {
          setFetchTrigger(fetchTrigger + 1);
        }}
        onIncomeAdd={() => {
          setFetchTrigger(fetchTrigger + 1);
        }}
        onIncomeRemove={() => {
          setFetchTrigger(fetchTrigger + 1);
        }}
        incomeId={selectedIncomeId}
      />
    </Container>
  );
};

export default Incomes;
